import axios from 'axios';
import authHeader from "@/service/auth-header";

class InvoiceComponentService {

    async getInvoiceComponentsForInvoice(invoiceId) {
        return await axios.get(`/api/invoicecomponent/${invoiceId}`,{ headers: authHeader() })
    }

    async createInvoiceComponent(invoiceId, data) {
        return await axios.post(`/api/invoicecomponent/${invoiceId}`, data,{ headers: authHeader() });
    }

    async updateInvoiceComponent(id, data) {
        return await axios.put(`/api/invoicecomponent/${id}`, data,{ headers: authHeader() });
    }

    async deleteInvoiceComponent(id) {
        return await axios.delete(`/api/invoicecomponent/${id}`,{ headers: authHeader() })
    }

}

export default new InvoiceComponentService();
